import $ from "jquery";
import "slick-carousel";

const relatedproductslider = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    const el = {
      slider: "#bd-related-product-cart .related-product",
    };

    if ($(el.slider).length === 0) return;

    $(el.slider).slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      arrows: true,
      prevArrow:
        '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><style>svg{fill:#000000}</style><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg></button>',
      nextArrow:
        '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><style>svg{fill:#000000}</style><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  };

  init();
};

try {
  $(window).on("load", () => {
    relatedproductslider();
  });
  // eslint-disable-next-line no-undef
  jQuery(document.body).on("wc_fragments_refreshed", function () {
    relatedproductslider();
  });
} catch (error) {
  // eslint-disable-next-line no-console
  console.error("relatedproductslider", error);
}

export default relatedproductslider;
